export const spaEndpointHost =  process.env.PUBLIC_URL;
export const apiHost = process.env.PUBLIC_URL;
export const getwayApi = process.env.PUBLIC_URL;
// export const apiHost = 'https://vra-test.azurewebsites.net/';
// export const getwayApi = 'https://vra-test.azurewebsites.net/';
export const vraUX =  process.env.PUBLIC_URL;
export const instkey = 'InstrumentationKey=4f254ea7-2eec-4f68-b038-744c9f7c9e5c';
export const captchaUrl = "https://captcha-dev.azurewebsites.net";
